// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xtd-city-card {
  flex: 0 0 auto;
  width: clamp(300px, 38vw, 400px);
  max-width: 100%;
  box-sizing: border-box;
  background: #111;
  border: 1px solid #374151;
  border-radius: 10px;
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
}

.xtd-city-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.xtd-city-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #f3f4f6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.xtd-city-card__badge {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 3px 8px;
  border-radius: 4px;
}

.xtd-city-card__badge--on {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
  border: 1px solid rgba(34, 197, 94, 0.35);
}

.xtd-city-card__badge--off {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.35);
}

.xtd-city-card__body {
  display: grid;
  grid-template-columns: minmax(88px, 110px) minmax(0, 1fr);
  gap: 10px 12px;
  align-items: center;
  min-width: 0;
}

.xtd-city-gauge {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.xtd-city-gauge__pct {
  margin-top: 2px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.1;
}

.xtd-city-gauge__pct--ok {
  color: #22c55e;
}

.xtd-city-gauge__pct--warn {
  color: #f59e0b;
}

.xtd-city-gauge__pct--bad {
  color: #ef4444;
}

.xtd-city-gauge__sub {
  margin-top: 4px;
  font-size: 11px;
  color: #9ca3af;
  text-align: center;
  line-height: 1.25;
  word-break: break-word;
}

.xtd-city-stats {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px 10px;
  min-width: 0;
}

.xtd-stat-block {
  min-width: 0;
  overflow: hidden;
  border-left: 1px solid #2a2a2a;
  padding-left: 8px;
}

.xtd-stat-block:first-child {
  border-left: none;
  padding-left: 0;
}

.xtd-stat-block__total {
  font-size: clamp(1.1rem, 3.2vw, 1.65rem);
  font-weight: 700;
  color: #fff;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.xtd-stat-block__heading {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #9ca3af;
  text-transform: uppercase;
}

.xtd-stat-block__pct {
  margin-top: 4px;
  font-size: 11px;
  color: #6b7280;
}

.xtd-onoff-list {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.xtd-onoff-row {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  line-height: 1.2;
  min-width: 0;
}

.xtd-onoff-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.xtd-onoff-dot--on {
  background: #22c55e;
}

.xtd-onoff-dot--off {
  background: #ef4444;
}

.xtd-onoff-label {
  color: #9ca3af;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 10px;
  letter-spacing: 0.04em;
}

.xtd-onoff-value {
  color: #e5e7eb;
  font-weight: 600;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}

.xtd-city-card__foot {
  font-size: 11px;
  color: #f87171;
  line-height: 1.35;
}

.xtd-city-card__retry {
  align-self: flex-start;
  margin-top: 2px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #374151;
  background: #1a1a1a;
  color: #e5e7eb;
  cursor: pointer;
}

.xtd-city-card__retry:hover:not(:disabled) {
  border-color: #4b5563;
  background: #222;
}

.xtd-city-card__retry:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .xtd-city-card {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 520px) {
  .xtd-city-card {
    width: 100%;
    max-width: 100%;
  }

  .xtd-city-card__body {
    grid-template-columns: 1fr;
  }

  .xtd-city-stats {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 360px) {
  .xtd-city-stats {
    grid-template-columns: 1fr;
  }

  .xtd-stat-block {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #2a2a2a;
    padding-top: 8px;
  }

  .xtd-stat-block:first-child {
    border-top: none;
    padding-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/xtamDashboard/CityStatusCard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":[".xtd-city-card {\n  flex: 0 0 auto;\n  width: clamp(300px, 38vw, 400px);\n  max-width: 100%;\n  box-sizing: border-box;\n  background: #111;\n  border: 1px solid #374151;\n  border-radius: 10px;\n  padding: 12px 14px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow: hidden;\n}\n\n.xtd-city-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n\n.xtd-city-card__title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f3f4f6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.xtd-city-card__badge {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 3px 8px;\n  border-radius: 4px;\n}\n\n.xtd-city-card__badge--on {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n  border: 1px solid rgba(34, 197, 94, 0.35);\n}\n\n.xtd-city-card__badge--off {\n  background: rgba(239, 68, 68, 0.12);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n}\n\n.xtd-city-card__body {\n  display: grid;\n  grid-template-columns: minmax(88px, 110px) minmax(0, 1fr);\n  gap: 10px 12px;\n  align-items: center;\n  min-width: 0;\n}\n\n.xtd-city-gauge {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 0;\n}\n\n.xtd-city-gauge__pct {\n  margin-top: 2px;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.1;\n}\n\n.xtd-city-gauge__pct--ok {\n  color: #22c55e;\n}\n\n.xtd-city-gauge__pct--warn {\n  color: #f59e0b;\n}\n\n.xtd-city-gauge__pct--bad {\n  color: #ef4444;\n}\n\n.xtd-city-gauge__sub {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #9ca3af;\n  text-align: center;\n  line-height: 1.25;\n  word-break: break-word;\n}\n\n.xtd-city-stats {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 8px 10px;\n  min-width: 0;\n}\n\n.xtd-stat-block {\n  min-width: 0;\n  overflow: hidden;\n  border-left: 1px solid #2a2a2a;\n  padding-left: 8px;\n}\n\n.xtd-stat-block:first-child {\n  border-left: none;\n  padding-left: 0;\n}\n\n.xtd-stat-block__total {\n  font-size: clamp(1.1rem, 3.2vw, 1.65rem);\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.xtd-stat-block__heading {\n  margin-top: 2px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  color: #9ca3af;\n  text-transform: uppercase;\n}\n\n.xtd-stat-block__pct {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.xtd-onoff-list {\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.xtd-onoff-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  line-height: 1.2;\n  min-width: 0;\n}\n\n.xtd-onoff-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.xtd-onoff-dot--on {\n  background: #22c55e;\n}\n\n.xtd-onoff-dot--off {\n  background: #ef4444;\n}\n\n.xtd-onoff-label {\n  color: #9ca3af;\n  flex-shrink: 0;\n  font-weight: 600;\n  font-size: 10px;\n  letter-spacing: 0.04em;\n}\n\n.xtd-onoff-value {\n  color: #e5e7eb;\n  font-weight: 600;\n  margin-left: auto;\n  font-variant-numeric: tabular-nums;\n}\n\n.xtd-city-card__foot {\n  font-size: 11px;\n  color: #f87171;\n  line-height: 1.35;\n}\n\n.xtd-city-card__retry {\n  align-self: flex-start;\n  margin-top: 2px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 1px solid #374151;\n  background: #1a1a1a;\n  color: #e5e7eb;\n  cursor: pointer;\n}\n\n.xtd-city-card__retry:hover:not(:disabled) {\n  border-color: #4b5563;\n  background: #222;\n}\n\n.xtd-city-card__retry:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .xtd-city-card {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 520px) {\n  .xtd-city-card {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .xtd-city-card__body {\n    grid-template-columns: 1fr;\n  }\n\n  .xtd-city-stats {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 360px) {\n  .xtd-city-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .xtd-stat-block {\n    border-left: none;\n    padding-left: 0;\n    border-top: 1px solid #2a2a2a;\n    padding-top: 8px;\n  }\n\n  .xtd-stat-block:first-child {\n    border-top: none;\n    padding-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
